import { Injectable } from '@angular/core';

/**
 * Thin wrapper around `window.location.pathname`. Wrapping this (rather than reading
 * `window.location` directly in consumers) lets consumers be unit-tested by mocking this
 * service — the same reason `ReloadService` wraps `window.location.reload()` (see that
 * service for why `window.location` itself cannot be spied on or redefined in this
 * project's unit-test environment).
 */
@Injectable({
  providedIn: 'root'
})
export class BrowserLocationService {
  public getPathname(): string {
    return window.location.pathname;
  }
}
